import { Box, IconProps, Tooltip } from "@mui/material"
import ActionCard from "../../../../../actionPlans/pages/form/components/actionCard"
import { icons } from "../../../../../../utils/icons"
import { copyText } from "../../../../../../utils/methods/copyText"
import { BodySectionActionIconsProps } from "./types"
import { useStyles } from "./styles"

const BodySectionActionIcons = ({ email, phone }: BodySectionActionIconsProps) => {
    const styles = useStyles()
    const handleCopy = ({ value }: { value: string }) => {
        copyText(value ?? '')
    }
    return (
        <Box sx={[styles.flex, styles.containerIcons]}>
            {!!email && <Box sx={styles.iconOutlined({ icon: 'email' })}>
                <ActionCard.Icon<IconProps> color='white' icon={<><Tooltip title={email}>{icons('emailOutlined')}</Tooltip></>} onClick={() => handleCopy({ value: email })} />
            </Box>}

            {(!!phone && phone?.length > 2) && (
                <Box sx={styles.iconOutlined({ icon: 'phone' })}>
                    <ActionCard.Icon<IconProps> color='white' icon={<><Tooltip title={phone}>{icons('phoneOutlined')}</Tooltip></>} onClick={() => handleCopy({ value: phone })} />
                </Box>
            )}
        </Box>
    )
}

export { BodySectionActionIcons }
